/**
 * StepIndicator component displays the current step in the stepper form.
 *
 * @param currentStep - The current step number (1, 2, or 3)
 */
interface StepIndicatorProps {
  currentStep: number;
}

export function StepIndicator({ currentStep }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-center mb-6">
      {[1, 2, 3].map((step) => (
        <div key={step} className="flex items-center">
          <div
            className={`w-6 h-6 rounded-full flex items-center justify-center text-sm font-medium ${
              currentStep === step
                ? "bg-primary text-primary-foreground"
                : currentStep > step
                  ? "bg-green-500 text-white"
                  : "bg-gray-200 text-gray-600"
            }`}
          >
            {currentStep > step ? "✓" : step}
          </div>
          {step < 3 && (
            <div
              className={`w-12 h-1 mx-2 ${
                currentStep > step ? "bg-green-500" : "bg-gray-200"
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
}
